export default __webpack_public_path__ + "static/media/stats.02a97b06.svg";